import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import Swal from 'sweetalert2'
import {KTIcon} from '../../../_payairo/helpers'
import {axiosClientAuth} from '../../utils'
import {useLayout} from '../../../_payairo/layout/core'

const AnnouncementRightToolbar = () => {
  const [input, setInput] = useState({
    title: '',
    description: '',
    announcement_type: '',
    user_type: '',
    scheduled_at: '',
  })

  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showSchedule, setShowSchedule] = useState(false)
  const {refreshAnnouncementList} = useLayout()

  const resetForm = () => {
    setShow(false)
    setShowSchedule(false)
    setInput({
      title: '',
      description: '',
      announcement_type: '',
      user_type: '',
      scheduled_at: '',
    })
  }

  const onChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setInput((prev) => ({...prev, [e.target.name]: e.target.value}))
  }

  const handleSubmit = async (isScheduled: boolean) => {
    if (!input.title.trim() || !input.description.trim()) {
      return Swal.fire({
        titleText: 'Error!',
        text: 'Title and Description are required.',
        icon: 'error',
        confirmButtonText: 'Ok! Got It',
      })
    }

    if (!input.announcement_type || !input.user_type) {
      return Swal.fire({
        titleText: 'Error!',
        text: 'Please fill all required fields.',
        icon: 'error',
        confirmButtonText: 'Ok! Got It',
      })
    }

    if (isScheduled && !input.scheduled_at) {
      return Swal.fire({
        titleText: 'Error!',
        text: 'Please select schedule date & time.',
        icon: 'error',
        confirmButtonText: 'Ok! Got It',
      })
    }

    try {
      setLoading(true)
      const payload: any = {
        title: input.title,
        description: input.description,
        announcement_type: input.announcement_type,
        user_type: input.user_type,
      }

      if (isScheduled) {
        payload.scheduled_at = input.scheduled_at
      }
      await axiosClientAuth.post('/auth/useradmin/announcements/create/', payload)
      refreshAnnouncementList()

      Swal.fire({
        titleText: 'Success!',
        text: isScheduled
          ? 'Announcement scheduled successfully!'
          : 'Announcement published successfully!',
        icon: 'success',
        confirmButtonText: 'Ok',
      }).then(() => resetForm())
    } catch (err) {
      Swal.fire({
        titleText: 'Error!',
        text: 'Failed to create announcement.',
        icon: 'error',
        confirmButtonText: 'Ok! Got It',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <button className='btn btn-sm fw-bold btn-primary' onClick={() => setShow(true)}>
        Create Announcement
      </button>

      <Modal show={show} className='modal fade modal-lg'>
        <div className='modal-header'>
          <h2 className='fw-bold'>Create Announcement</h2>
          <div className='d-flex justify-content-end'>
            <button
              className='ms-auto btn btn-sm btn-icon btn-active-color-primary'
              onClick={resetForm}
            >
              <KTIcon iconName='cross' className='text-gray fs-1' />
            </button>
          </div>
        </div>

        <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
          <form className='form'>
            <div className='d-flex flex-column scroll-y me-n7 pe-7'>
              {/* Announcement Type */}
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Announcement Type</label>
                <select
                  name='announcement_type'
                  value={input.announcement_type}
                  onChange={onChangeHandler}
                  className='form-select form-select-solid'
                >
                  <option value=''>Select Type</option>
                  <option value='General'>General</option>
                  <option value='Update'>Update</option>
                  <option value='Alert'>Alert</option>
                </select>
              </div>

              {/* User Type */}
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>User Type</label>
                <select
                  name='user_type'
                  value={input.user_type}
                  onChange={onChangeHandler}
                  className='form-select form-select-solid'
                >
                  <option value=''>Select User Type</option>
                  <option value='User'>User</option>
                  {/* <option value='All'>All</option>
                                    <option value='Cybrid'>Cybrid</option>
                                    <option value='Fortress'>Fortress</option> */}
                </select>
              </div>

              {/* Title */}
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Title</label>
                <input
                  type='text'
                  name='title'
                  value={input.title}
                  onChange={onChangeHandler}
                  className='form-control form-control-solid'
                  placeholder='Enter announcement title'
                />
              </div>

              {/* Description */}
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Description</label>
                <textarea
                  name='description'
                  value={input.description}
                  onChange={onChangeHandler}
                  className='form-control form-control-solid'
                  rows={3}
                  placeholder='Enter announcement description'
                />
              </div>

              {/* Show only if Scheduling */}
              {showSchedule && (
                <div className='fv-row mb-7'>
                  <label className='required fw-semibold fs-6 mb-2'>Schedule Date & Time</label>
                  <input
                    type='datetime-local'
                    name='scheduled_at'
                    value={input.scheduled_at}
                    onChange={onChangeHandler}
                    className='form-control form-control-solid'
                  />
                </div>
              )}
            </div>

            {/* Action Buttons */}
            <div className='text-center pt-15 d-flex justify-content-center gap-3'>
              <button type='button' className='btn btn-light' onClick={resetForm}>
                Discard
              </button>

              <button
                type='button'
                className='btn btn-primary'
                disabled={loading}
                onClick={() => handleSubmit(false)}
              >
                {!loading ? 'Submit Now' : 'Please wait...'}
              </button>

              <button
                type='button'
                className='btn btn-warning'
                onClick={() => setShowSchedule(true)}
              >
                Schedule for Later
              </button>

              {showSchedule && (
                <button
                  type='button'
                  className='btn btn-success'
                  disabled={loading}
                  onClick={() => handleSubmit(true)}
                >
                  {!loading ? 'Confirm Schedule' : 'Please wait...'}
                </button>
              )}
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

export default AnnouncementRightToolbar
